import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAthleteAuth } from "../../lib/athleteAuth";
import { toast } from "sonner";

export default function AthleteLoginPage() {
  const { login } = useAthleteAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const next = new URLSearchParams(location.search).get("next") || "/athlete/home";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate(next, { replace: true });
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--tir-ivory)] flex flex-col" data-testid="athlete-login-page">
      <div className="max-w-md w-full mx-auto px-6 py-10 flex-1 flex flex-col justify-center">
        <Link to="/" className="font-eyebrow text-[10px] tracking-[0.24em] uppercase text-[var(--tir-muted)] hover:text-[var(--tir-burgundy)] inline-flex items-center gap-1 mb-8">
          <ArrowLeft size={11} /> Back
        </Link>
        <div className="font-eyebrow text-[11px] tracking-[0.32em] uppercase font-semibold text-[var(--tir-navy)] mb-2">
          Athlete Portal
        </div>
        <h1 className="font-serif-display text-4xl lg:text-5xl text-[var(--tir-ink)] mb-1">
          Sign in
        </h1>
        <p className="text-sm text-[var(--tir-muted)] mb-8">
          Use the email your coach has on file.
        </p>

        <form onSubmit={submit} className="space-y-5">
          <div>
            <label className="font-eyebrow block text-[10px] tracking-[0.22em] uppercase font-semibold text-[var(--tir-muted)] mb-1">
              Email
            </label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="athlete-login-email"
              className="w-full bg-white border border-[var(--tir-border)] focus:border-[var(--tir-navy)] px-3 py-2.5 text-base focus:outline-none"
              autoFocus
            />
          </div>
          <div>
            <label className="font-eyebrow block text-[10px] tracking-[0.22em] uppercase font-semibold text-[var(--tir-muted)] mb-1">
              Password
            </label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="athlete-login-password"
              className="w-full bg-white border border-[var(--tir-border)] focus:border-[var(--tir-navy)] px-3 py-2.5 text-base focus:outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="athlete-login-submit"
            className="w-full py-3 bg-[var(--tir-navy)] hover:bg-[var(--tir-navy)]/90 text-white font-eyebrow text-xs tracking-[0.24em] uppercase font-semibold disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="mt-8 text-[11px] text-[var(--tir-muted)] text-center leading-relaxed">
          Don't have access yet? Ask your coach to send you an invite.
        </div>
      </div>
    </div>
  );
}
